/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SearchTypeEnum {
	SEMANTIC = 'semantic',
	KEYWORD = 'keyword',
	MEMBERSHIP = 'membership'
}
